import React, { useEffect, useState } from 'react';
import {
  getAllAppMethod,
  getAllCollisionCompanies,
  getAllLevel,
  getAllSemester,
  getAllSemesterYear,
  getAllSubject,
} from '../../util/DatabaseUtil';

// TODO: File needs to be reworked, very hard to read and calls DB too much

export function ContextQuestions({
  cat,
  updateRating,
  checkContext,
  formData,
}) {
  const [subject, setSubject] = useState([]);
  const [semester, setSemester] = useState([]);
  const [semesterYear, setSemesterYear] = useState([]);
  const [level, setLevel] = useState([]);
  const [appmethod, setAppMethod] = useState([]);
  const [companies, setCompanies] = useState([]);

  // TODO: Possibly use Promise All instead of this
  useEffect(() => {
    const fetchAllContextQuestions = async () => {
      try {
        const semesterData = await getAllSemester();
        const yearData = await getAllSemesterYear();
        const subjectData = await getAllSubject();
        const levelData = await getAllLevel();
        const appMethodData = await getAllAppMethod();
        const collisionData = await getAllCollisionCompanies();

        semesterData.forEach((index) => {
          setSemester((semester) => [...semester, index.semesterName]);
        });
        yearData.forEach((index) => {
          setSemesterYear((semesterYear) => [...semesterYear, index.year]);
        });
        subjectData.forEach((index) => {
          setSubject((subjects) => [...subjects, index.description]);
        });
        levelData.forEach((index) => {
          setLevel((level) => [...level, index.descA]);
        });
        appMethodData.forEach((index) => {
          setAppMethod((appmethod) => [...appmethod, index.am_type]);
        });

        // TODO:Uncomment when ready
        collisionData.forEach((index) => {
          setCompanies((appmethod) => [...appmethod, index.company]);
        });
      } catch (err) {
        console.error('Error fetching All Data', err);
      }
    };

    fetchAllContextQuestions();
  }, []);

  const contextQuestions = React.useMemo(() => {
    const categoryContextQuestions = {
      school: [
        {
          type: 'select',
          label: 'Subject',
          options: subject,
          databaseName: 'subject',
        },
        {
          type: 'select',
          label: 'Year',
          options: semesterYear,
          databaseName: 'year',
        },
        {
          type: 'select',
          label: 'Semester',
          options: semester,
          databaseName: 'semester',
        },
      ],
      class: [
        {
          type: 'select',
          label: 'Subject',
          options: subject,
          databaseName: 'subject',
        },
        {
          type: 'select',
          label: 'Year',
          options: semesterYear,
          databaseName: 'year',
        },
        {
          type: 'select',
          label: 'Level',
          options: level,
          databaseName: 'level',
        },
        {
          type: 'select',
          label: 'Semester',
          options: semester,
          databaseName: 'semester',
        },
      ],
      textbook: [
        { type: 'input', label: 'ISBN', databaseName: 'resourceISBN' },
        {
          type: 'select',
          label: 'Subject',
          options: subject,
          databaseName: 'subject',
        },
        {
          type: 'select',
          label: 'Level',
          options: level,
          databaseName: 'level',
        },
        {
          type: 'select',
          label: 'Year',
          options: semesterYear,
          databaseName: 'year',
        },
        {
          type: 'select',
          label: 'Semester',
          options: semester,
          databaseName: 'semester',
        },
        {
          type: 'select',
          label: 'Cost',
          options: [
            'Cost Not Available',
            '$1 - $9.99',
            '$10 - $29.99',
            '$30 - $49.99',
            '$50 - $99.99',
            '$100 - $149',
            '$150 - $199',
            '$200+',
            'Free',
          ],
          databaseName: 'cost',
        },
      ],
      onlineresource: [
        { type: 'input', label: 'URL', databaseName: 'resourceUrl' },
        {
          type: 'select',
          label: 'Subject',
          options: subject,
          databaseName: 'subject',
        },
        {
          type: 'select',
          label: 'Level',
          options: level,
          databaseName: 'level',
        },
        {
          type: 'select',
          label: 'Year',
          options: semesterYear,
          databaseName: 'year',
        },
        {
          type: 'select',
          label: 'Semester',
          options: semester,
          databaseName: 'semester',
        },
      ],
      onlinelearning: [
        {
          type: 'select',
          label: 'Subject',
          options: subject,
          databaseName: 'subject',
        },
        {
          type: 'select',
          label: 'Year',
          options: semesterYear,
          databaseName: 'year',
        },
        {
          type: 'select',
          label: 'Semester',
          options: semester,
          databaseName: 'semester',
        },
      ],
      misdis: [
        { type: 'input', label: 'URL', databaseName: 'resourceUrl' },
        {
          type: 'select',
          label: 'Subject',
          options: subject,
          databaseName: 'subject',
        },
        {
          type: 'select',
          label: 'Level',
          options: level,
          databaseName: 'level',
        },
        {
          type: 'select',
          label: 'Year',
          options: semesterYear,
          databaseName: 'year',
        },
        {
          type: 'select',
          label: 'Semester',
          options: semester,
          databaseName: 'semester',
        },
      ],
      jobprospect: [
        {
          type: 'select',
          label: 'Year',
          options: semesterYear,
          databaseName: 'year',
        },
        {
          type: 'select',
          label: 'Semester',
          options: semester,
          databaseName: 'semester',
        },
      ],
      applicationprocess: [
        { type: 'select', label: 'Application Method', options: appmethod },
        {
          type: 'select',
          label: 'Year',
          options: semesterYear,
          databaseName: 'year',
        },
        {
          type: 'select',
          label: 'Cost',
          options: [
            'Cost Not Available',
            '$1 - $9.99',
            '$10 - $29.99',
            '$30 - $49.99',
            '$50 - $99.99',
            '$100 - $149',
            '$150 - $199',
            '$200+',
            'Free',
          ],
          databaseName: 'cost',
        },
      ],
      mentalhealth: [
        {
          type: 'select',
          label: 'Subject',
          options: subject,
          databaseName: 'subject',
        },
        {
          type: 'select',
          label: 'Year',
          options: semesterYear,
          databaseName: 'year',
        },
        {
          type: 'select',
          label: 'Semester',
          options: semester,
          databaseName: 'semester',
        },
      ],
      article: [
        { type: 'input', label: 'URL', databaseName: 'resourceUrl' },
        {
          type: 'select',
          label: 'Subject',
          options: subject,
          databaseName: 'subject',
        },
        {
          type: 'select',
          label: 'Level',
          options: level,
          databaseName: 'level',
        },
        {
          type: 'select',
          label: 'Year',
          options: semesterYear,
          databaseName: 'year',
        },
        {
          type: 'select',
          label: 'Semester',
          options: semester,
          databaseName: 'semester',
        },
      ],
      movie: [
        {
          type: 'select',
          label: 'Platform',
          options: [
            'YouTube',
            'Tubi',
            'Hulu',
            'Disney+',
            'Apple TV+',
            'Netflix',
            'Amazon Prime',
            'HBO Max',
            'Starz',
            'Other',
          ],
          databaseName: 'platform',
        },
      ],
      tv: [
        {
          type: 'select',
          label: 'Platform',
          options: [
            'YouTube',
            'Tubi',
            'Hulu',
            'Disney+',
            'Netflix',
            'Amazon Prime',
            'HBO Max',
            'Starz',
            'Other',
          ],
          databaseName: 'platform',
        },
      ],
      game: [
        {
          type: 'select',
          label: 'Platform',
          options: [
            'PC',
            'Xbox',
            'PlayStation',
            'Nintendo',
            'Apple Macintosh',
            'Linux',
          ],
          databaseName: 'platform',
        },
      ],
      collision: [
        {
          type: 'search',
          label: 'Company',
          options: companies, //pull from database
          databaseName: 'company',
        },
      ],
    };
    return categoryContextQuestions[cat] || [];
  }, [cat, subject, semesterYear, semester, level, appmethod, companies]);

  // Determines if all context questions have been filled
  useEffect(() => {
    let hasEmptyValue = false;
    contextQuestions.forEach((question) => {
      const value = formData[question.databaseName];
      if (value === undefined || value === null || value === '') {
        hasEmptyValue = true;
      }
    });

    if (hasEmptyValue) {
      checkContext(false);
    } else {
      checkContext(true);
    }
  }, [formData, contextQuestions, checkContext]);

  return (
    <>
      {companies && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
          {contextQuestions.map((question, idx) => (
            <div className="flex flex-col space-y-2 w-full" key={idx}>
              <label className="text-sm font-semibold text-slate-200">
                {question.label} <span className="text-red-500">*</span>
              </label>

              {question.type === 'select' && (
                <div className="relative w-full">
                  <select
                    className={`w-full bg-slate-900/60 border text-white rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500/50 transition-all duration-200 appearance-none cursor-pointer ${
                      !formData[question.databaseName]
                        ? 'border-red-500/50'
                        : 'border-slate-700'
                    }`}
                    value={formData[question.databaseName] || ''}
                    id={`context-${idx}`}
                    onChange={(e) =>
                      updateRating({ [question.databaseName]: e.target.value })
                    }
                  >
                    <option value="" disabled>
                      Select...
                    </option>
                    {question.options.map((opt, optIdx) => (
                      <option key={optIdx} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                  <svg
                    className="absolute right-3 top-3.5 w-4 h-4 text-slate-500 pointer-events-none"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              )}

              {question.type === 'input' && (
                <div className="w-full">
                  <input
                    type="text"
                    className={`w-full bg-slate-900/60 border text-white placeholder-slate-500 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500/50 transition-all duration-200 ${
                      !formData[question.databaseName]
                        ? 'border-red-500/50'
                        : 'border-slate-700'
                    }`}
                    id={`input-${idx}`}
                    value={formData[question.databaseName] || ''}
                    placeholder={`Enter ${question.label}`}
                    onChange={(e) =>
                      updateRating({ [question.databaseName]: e.target.value })
                    }
                  />
                </div>
              )}

              {question.type === 'search' && (
                <div className="relative w-full">
                  <input
                    type="text"
                    className={`w-full bg-slate-900/60 border text-white placeholder-slate-500 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500/50 transition-all duration-200 ${
                      !formData[question.databaseName]
                        ? 'border-red-500/50'
                        : 'border-slate-700'
                    }`}
                    id={idx}
                    onChange={(e) =>
                      updateRating({ [question.databaseName]: e.target.value })
                    }
                    value={formData[question.databaseName] || ''}
                    placeholder={`Search ${question.label}...`}
                  />
                  {formData[question.databaseName] && (
                    <div className="absolute left-0 right-0 mt-2 bg-slate-800 border border-slate-700 max-h-60 overflow-y-auto rounded-xl shadow-xl z-50">
                      {question.options
                        .filter((item) => {
                          const searchTerm =
                            formData[question.databaseName].toLowerCase();
                          const companyName = item?.toLowerCase() || '';
                          return (
                            searchTerm &&
                            companyName.includes(searchTerm) &&
                            companyName !== searchTerm
                          );
                        })
                        .map((option, searchIdx) => (
                          <div
                            onClick={() =>
                              updateRating({
                                [question.databaseName]: option,
                              })
                            }
                            className="px-4 py-3 text-sm text-slate-200 hover:bg-slate-700 hover:text-white cursor-pointer transition-colors border-b last:border-0 border-slate-700/50"
                            key={searchIdx}
                          >
                            {option}
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
}
